/* @flow */

export default class ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
  twoFactorPin: string;
  smsCode: string;
}
